import DateProxy from './DateProxy';
const fdate = (strArr, ...args) => (date) => {
    const proxy = new DateProxy(date);
    return String.raw(strArr, ...args.map((argv) => (typeof argv === 'string' ? proxy[argv] : argv(proxy))));
};
export default fdate;
//# sourceMappingURL=index.js.map